// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1FRr-","content":"ManualTimeModal_content__ALXrj"};